import { inject, Injectable } from '@angular/core';
import { ApiService } from '@core/services';
import { Building } from '../models';
import { Observable } from 'rxjs';
import { BussinesService } from '../../public/services/bussines.service';

@Injectable({
  providedIn: 'root',
})
export class BuildingService {
  private apiService = inject(ApiService);
  private bussinesService = inject(BussinesService);

  storeBuilding(data: Building) {
    console.log('STORE BUILDING', data);
    return this.apiService.store(
      `building?name=${data.name}&code=${data.code}&address=${data.address}&businessid=${data.idBusiness}&countryid=${data.country_id}&latitude=${data.latitude} &longitude=${data.longitude}`,
      undefined
    );
  }

  getBuildings(businessId?: number): Observable<any> {
    if (businessId) {
      return this.apiService.getAll(`building?businessid=${businessId}`);
    } else {
      return this.apiService.getAll(
        `building?businessid=${this.bussinesService.getBussinesId()}`
      );
    }
  }

  getBuildingsByBusiness(idBusiness: number): Observable<any> {
    return this.apiService.getAll(`building?businessid=${idBusiness}`);
  }

  getBuilding(id: number): Observable<any> {
    return this.apiService.getById('building', id);
  }

  deleteBuilding(id: number) {
    return this.apiService.delete('building', id);
  }

  updateBuilding(data: Building, id: number) {
    console.log('UPDATE BUILDING', data);
    return this.apiService.update(
      `building/${id}?name=${data.name}&code=${data.code}&address=${data.address}&businessid=${data.idBusiness}&countryid=${data.country_id}&latitude=${data.latitude} &longitude=${data.longitude}`,
      undefined,
      id
    );
  }

  getBuildingsByCountry(countryID: number) {
    return this.apiService.getAll(
      `building?businessid=${this.bussinesService.getBussinesId()}&countryid=${countryID}`
    );
  }
}
